module.exports = __webpack_public_path__ + "media/images/property_photo1-a9003a40.jpg";